import { DATA_PAGINATION, Emitter } from '@/types'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface Props {
  data?: DATA_PAGINATION<Emitter>
}

const EmitterTable: FC<Props> = ({ data }) => {
  return (
    <Stack flexGrow="1" justifyContent="space-between">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  width: '29px',
                  position: 'sticky',
                  left: 0,
                }}
              >
                #
              </TableCell>
              <TableCell
                sx={{
                  width: '182px',
                  boxShadow: 'inset -1px 0px 0px #D7D7D7',
                  position: 'sticky',
                  left: 0,
                }}
              >
                Emitter
              </TableCell>
              <TableCell>Efficiency</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.data.map((row) => (
              <TableRow key={row.id}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ position: 'sticky', left: 0 }}
                >
                  {row.id}
                </TableCell>
                <TableCell
                  sx={{
                    width: '182px',
                    boxShadow: 'inset -1px 0px 0px #D7D7D7',
                    position: 'sticky',
                    left: 0,
                  }}
                >
                  {row?.emitter}
                </TableCell>
                <TableCell>{row?.efficiency}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default EmitterTable
